<template>
  <vs-popup id="targetReviewer" :active.sync="isActive" title="Hedef Detayları" v-esc="escape">
    <vs-row vs-type="flex" vs-w="12">
      <vs-row id="targetInfo" vs-type="flex" vs-w="12" class="bg-secondary py-5 px-5 my-1">
        <vs-row vs-type="flex" vs-w="12" vs-align="center">
          <vs-col vs-type="flex" vs-w="6" vs-justify="flex-start" vs-align="center">
            <vs-row vs-type="flex" vs-w="12">
              <vs-col vs-type="flex" vs-w="2" vs-align="center" class="pr-1">
                <vs-button v-if="target.kind == 1" size="large" class="w-full targetTypeAvatar" type="filled"
                  color="rgb(60, 232, 196)" icon-pack="pickicon" icon="icon-products" />
                <vs-button v-if="target.kind == 2" size="large" class="w-full targetTypeAvatar" type="filled"
                  color="rgb(142, 224, 232)" icon-pack="pickicon" icon="icon-rich" />
                <vs-button v-if="target.kind == 3" size="large" class="w-full targetTypeAvatar" type="filled"
                  color="rgb(255, 159, 67)" icon-pack="feather" icon="icon-layers" />
              </vs-col>
              <vs-col vs-type="flex" vs-w="10">
                <vs-row vs-type="flex" vs-w="12">
                  <vs-row vs-type="flex" vs-w="12">
                    <span v-if="target.kind == 1" class="text-dark text-small bold">
                      Ürün Hedefi
                    </span>
                    <span v-if="target.kind == 2" class="text-dark text-small bold">
                      Ciro Hedefi
                    </span>
                    <span v-if="target.kind == 3" class="text-dark text-small bold">
                      Kategori Hedefi
                    </span>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12">
                    <span v-if="target.kind == 1" class="text-secondary text-smaller weight-600">
                      {{target.targetQuantity + ' Adet ' + (target.product ? target.product.name : '')}}
                    </span>
                    <span v-if="target.kind == 2" class="text-secondary text-smaller weight-600">
                      {{$toCurrency(target.targetQuantity)}}
                    </span>
                    <span v-if="target.kind == 3" class="text-secondary text-smaller weight-600">
                      {{target.targetQuantity + ' Adet ' + (target.category ? target.category.name : '')}}
                    </span>
                  </vs-row>
                </vs-row>
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" vs-justify="flex-end" vs-align="center">
            <span v-if="target.daysToExpire != 0" class="text-danger text-smaller weight-600">
              {{target.daysToExpire + ' Gün Kaldı'}}
            </span>
            <span v-if="target.daysToExpire == 0" class="text-danger text-smaller weight-600">
              Gün Sonunda Bitiyor
            </span>
          </vs-col>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" vs-align="center" class="mt-4">
          <vs-row vs-type="flex" vs-w="12" v-if="target.targetPersonals != null">
            <vs-progress :percent="target.targetProcess * 100 / target.targetPersonals.length"
              :color="target.kind == 3 ? 'rgb(255, 159, 67)' : (target.kind == 2 ? 'rgb(142, 224, 232)' : 'rgb(60, 232, 196)')">
            </vs-progress>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12">
            <vs-col v-if="target.status == 'InProgress' || target.status == 1" vs-type="flex" vs-w="6" vs-justify="flex-start">
              <span class="text-secondary bold text-smaller">
                {{target.targetProcess + ' Personel Tamamlamış'}}
              </span>
            </vs-col>
            <vs-col v-if="target.status == 'InProgress' || target.status == 1" vs-type="flex" vs-w="6" vs-justify="flex-end">
              <span class="text-secondary bold text-smaller">
                {{target.targetPersonals.length + ' Personel'}}
              </span>
            </vs-col>
            <vs-col v-if="target.status == 'Finished' || target.status == 2" vs-type="flex" vs-w="12" vs-justify="flex-end">
              <span class="w-full text-center text-success bold text-smaller">
                Tüm Personel({{target.targetPersonals.length}}) Hedefe Ulaştı !
              </span>
            </vs-col>
          </vs-row>
        </vs-row>
      </vs-row>
      <vs-row id="targetPersonalList" vs-type="flex" vs-w="12" class="py-2 px-3 my-1">
        <vs-row class="targetPersonalRow cursor-pointer" vs-type="flex" vs-w="12" vs-align="center"
          v-for="(personal,index) in target.targetPersonals" :key="index" @click.native="$emit('show-detail', target, personal)" title="Tıklayarak Sipariş Kanıt Detayını İnceleyin">
          <vs-col vs-type="flex" vs-w="0.5" vs-align="center" vs-justify="center">
            <span class="text-primary weight-600 text-smaller">
              {{index+1}}.
            </span>
          </vs-col>
          <vs-col vs-type="flex" vs-w="1.2" vs-align="center" vs-justify="flex-start" style="padding-right: 8px;">
            <div class="vs-avatar" style="width: 38px; height: 38px; border-radius: 50%; overflow: hidden; display: flex; align-items: center; justify-content: center; background-color: #f1f2f5; border: 1px solid rgba(0,0,0,0.05);">
              <img v-if="personal.user && personal.user.image && !personal.user.imageError" 
                   :src="getAvatar(personal.user.image)" 
                   @error="$set(personal.user, 'imageError', true)" 
                   style="width: 100%; height: 100%; object-fit: cover;" />
              <feather-icon v-else icon="UserIcon" svgClasses="w-5 h-5 text-secondary stroke-current" />
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-w="4.5">
            <span class="text-dark bold text-smaller">
              {{personal.user.name}}
            </span>
          </vs-col>
          <vs-col vs-type="flex" vs-w="5">
            <vs-row vs-type="flex" vs-w="12">
              <vs-row vs-type="flex" vs-w="12" vs-align="center">
                <vs-progress :percent="personal.targetProcess * 100 / target.targetQuantity"
                  :color="target.kind == 2 ? 'rgb(142, 224, 232)' : 'rgb(60, 232, 196)'">
                </vs-progress>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12" vs-align="center" vs-justify="flex-end">
                <span class="text-dark weight-600 text-smaller mr-2">
                  {{personal.targetProcess}}{{' '}}{{target.kind == 2 ? '₺' : 'Adet'}}
                </span>
                <feather-icon icon="SearchIcon" svgClasses="w-4 h-4 text-primary" />
              </vs-row>
            </vs-row>
          </vs-col>
        </vs-row>
      </vs-row>
    </vs-row>
  </vs-popup>
</template>

<script>
  export default {
    data() {
      return {
        isActive: false
      }
    },
    props: {
      target: {
        required: true,
        type: Object
      }
    },
    methods: {
      escape() {
        if (this.isActive == true) this.isActive = false;
      },
      getAvatar(image) {
        if (image == null) return this.$nullImage;
        else return this.$baseUrl + '/' + image;
      }
    },
    watch: {
      isActive(val) {
        if (!val) this.$emit("close");
      }
    }
  }

</script>

<style>
  #targetReviewer .vs-popup--content {
    padding: 0 !important;
    margin: 0 !important;
    width: 100% !important;
  }

  #targetInfo {
    box-shadow: 0px 0px 1px 3px #00000030;
  }

  .targetPersonalRow {
    padding-top: .25rem;
    padding-bottom: .25rem;
  }

  .targetPersonalRow:hover {
    background-color: #00000010;
  }

</style>
